import UtilsService from '../../Services/UtilsService';

export function logIn(): void {
    UtilsService.redirectTo('/app/login');
}
